import { useTranslation } from 'react-i18next'

import { DashboardTemplate, ProtectedPage } from '~/src/components/templates'

/**
 * Dashboard
 * @constructor
 */
export const Dashboard: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  return (
    <ProtectedPage pageTitle={`${t('dashboard.home')}`}>
      <DashboardTemplate />
    </ProtectedPage>
  )
}
